import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/indexTestDoubleVideo.vue'
import Grant from '../views/home/pages/grantWX.vue'
import Same from '../views/home/pages/same.vue'
import Pay from '../views/home/pages/payJump.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '会销售的AI智能体' }
  },
  {
    path: '/grant',
    name: 'grant',
    component: Grant,
    meta: { title: '微信授权' }
  },
  {
    path: '/same',
    name: 'same',
    component: Same,
    meta: { title: '获取同款' }
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay,
    meta: { title: '支付结果' }
  }
  // {
  //   path: '/shop',
  //   beforeEnter(to, from, next) {
  //     // window.location.href = decodeURIComponent(to.params.url);
  //     window.location.replace(decodeURIComponent(to.params.url));
  //   }
  // }
]

const router = new VueRouter({
 /*  mode: 'history', // 支付界面不支持return 带#
  base: '/myapp/', */
  routes
})

// 导航守卫设置页面标题
router.beforeEach((to, from, next) => {
  next()
})
export default router
